import { useTranslation } from "react-i18next";
import { useGetAdminLicenseStatsQuery } from "../../query/adminLicenseStatsQuery";
import { isSalesToday } from "../../utils/dailySalesUtils";
import { StatBox } from "../../components/StatBox";
import { Row } from "../../components/Row";
import { spacing } from "@styling/sizing";

interface DashboardValueBoxesProps {
  date: string;
  selectedDateLabel: string;
}

export const DashboardValueBoxes = ({
  date,
  selectedDateLabel,
}: DashboardValueBoxesProps) => {
  const { t } = useTranslation();
  const { data: stats } = useGetAdminLicenseStatsQuery(date, date);
  const isToday = isSalesToday(date);

  const dayStats = stats?.[0];

  return (
    <Row $gap={spacing.x2}>
      <StatBox
        label={
          isToday
            ? t("adminLicenseStats.uniqueStoresToday")
            : t("adminLicenseStats.uniqueStoresOnDate", {
                date: selectedDateLabel,
              })
        }
        value={dayStats?.uniqueStoresCount ?? "-"}
      />
      <StatBox
        label={
          isToday
            ? t("adminLicenseStats.totalLicensesToday")
            : t("adminLicenseStats.totalLicensesOnDate", {
                date: selectedDateLabel,
              })
        }
        value={dayStats?.totalLicenses ?? "-"}
      />
      <StatBox
        label={
          isToday
            ? t("adminLicenseStats.packagesToday")
            : t("adminLicenseStats.packagesOnDate", {
                date: selectedDateLabel,
              })
        }
        value={dayStats?.licensesByType?.PACKAGE ?? "-"}
      />
      <StatBox
        label={
          isToday
            ? t("adminLicenseStats.addOnsToday")
            : t("adminLicenseStats.addOnsOnDate", {
                date: selectedDateLabel,
              })
        }
        value={dayStats?.licensesByType?.ADD_ON ?? "-"}
      />
    </Row>
  );
};
